import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button, makeStyles } from '@material-ui/core';
import { PropTypes } from 'prop-types';
import SettingsButton from '~/modules/common/components/ListTableToolBar/SettingsButton';
import { useIsBreakpointDown } from '~/modules/common/hooks';
import { useMeContext } from '~/modules/me';
import { RESOURCE_MANAGEMENT_DASHBOARD_TAB_ENUM } from '~/modules/resource-management/common/enums/resourceManagementDashboardTabs';
import TargetUtilizationSettingsButton from '~/modules/resource-management/ResourceManagementDashboard/components/TargetUtilizationSettingsButton';
import { DEFAULT_TARGET_UTILIZATION } from '~/modules/resource-management/ResourceManagementDashboard/hooks/useTargetUtilizationSettings';
import { RESOURCE_MANAGEMENT_TAB_ENUM } from '../../enums';
import ResourceManagementImportExportMenu from '../ResourceManagementImportExportMenu';

const useStyles = makeStyles(() => ({
  margin: {
    marginLeft: 'auto'
  }
}));

export const ResourceManagementActionIcons = ({
  onSettingsClick,
  onTargetUtilizationClick,
  selectedTab,
  selectedDashboardTab,
  isTargetUtilizationLoading,
  targetUtilization = DEFAULT_TARGET_UTILIZATION
}) => {
  const {
    uiRootPath,
    permissionsMap,
    featureFlags: {
      isPsaRmpBenchOverallocationEnabled,
      isPsaRmpSkillAnalyticsEnabled
    }
  } = useMeContext();

  const isMobile = useIsBreakpointDown('sm');
  const showSettingsButton =
    !isMobile && selectedTab === RESOURCE_MANAGEMENT_TAB_ENUM.LIST;
  const showResourcePoolShortcut =
    permissionsMap['urn:replicon:resource-pool-action:view-resource-pool'] &&
    [
      RESOURCE_MANAGEMENT_TAB_ENUM.LIST,
      RESOURCE_MANAGEMENT_TAB_ENUM.TIMELINE
    ].includes(selectedTab);

  const showTargetUtilizationButton =
    isPsaRmpSkillAnalyticsEnabled &&
    isPsaRmpBenchOverallocationEnabled &&
    selectedTab === RESOURCE_MANAGEMENT_TAB_ENUM.OVERVIEW &&
    selectedDashboardTab === RESOURCE_MANAGEMENT_DASHBOARD_TAB_ENUM.INSIGHTS;

  const classes = useStyles();
  const intl = useIntl();

  return (
    <div className={classes.margin}>
      {showResourcePoolShortcut && !isMobile && (
        <Button color="primary" href={`${uiRootPath}admin/resource-pools`}>
          <FormattedMessage id="resourceManagement.resourcePools" />
        </Button>
      )}
      <ResourceManagementImportExportMenu
        isMobile={isMobile}
        selectedTab={selectedTab}
      />
      {showSettingsButton && (
        <SettingsButton
          data-qe-id="ResourceSettingButton"
          onClick={onSettingsClick}
          aria-label={intl.formatMessage({
            id: 'resourceManagement.settingsButton'
          })}
        />
      )}
      {showTargetUtilizationButton && (
        <TargetUtilizationSettingsButton
          targetUtilization={targetUtilization}
          isLoading={isTargetUtilizationLoading}
          onClick={onTargetUtilizationClick}
        />
      )}
    </div>
  );
};

ResourceManagementActionIcons.propTypes = {
  onSettingsClick: PropTypes.func.isRequired,
  onTargetUtilizationClick: PropTypes.func,
  selectedTab: PropTypes.oneOf([
    RESOURCE_MANAGEMENT_TAB_ENUM.TIMELINE,
    RESOURCE_MANAGEMENT_TAB_ENUM.LIST,
    RESOURCE_MANAGEMENT_TAB_ENUM.OVERVIEW
  ]),
  selectedDashboardTab: PropTypes.string,
  isTargetUtilizationLoading: PropTypes.bool,
  targetUtilization: PropTypes.number
};

export default ResourceManagementActionIcons;
